import { Link } from "react-router-dom";
import { TONE } from "./Primitives";

/**
 * Signature stat tile: uppercase label, tinted icon chip, big serif figure,
 * one muted context line, optional delta vs a comparison period.
 */
export const StatTile = ({
  label, value, hint, icon: Icon, tone = "neutral", delta, deltaLabel,
  to, testid, gold, size = "md", onClick,
}) => {
  const valueSize = size === "lg" ? "text-4xl sm:text-5xl" : "text-3xl sm:text-4xl";
  const inner = (
    <div
      className="border border-border bg-card p-5 h-full flex flex-col hover:border-primary/30 transition-colors duration-200"
      data-testid={testid}
    >
      <div className="flex items-start justify-between gap-3 mb-5">
        <div className="label-mono leading-relaxed">{label}</div>
        {Icon && (
          <span className={`shrink-0 w-8 h-8 rounded-xl border flex items-center justify-center ${TONE[tone]}`}>
            <Icon size={15} weight="regular" />
          </span>
        )}
      </div>
      <div className={`font-heading ${valueSize} tnum leading-none ${gold ? "text-primary" : ""}`} data-testid={testid ? `${testid}-value` : undefined}>
        {value}
      </div>
      {(hint || delta !== undefined) && (
        <div className="mt-2.5 text-xs text-muted-foreground flex items-center gap-2 flex-wrap">
          {delta !== undefined && delta !== null && (
            <span className={`tnum font-medium ${Number(delta) >= 0 ? "text-emerald-400" : "text-red-400"}`}>
              {Number(delta) >= 0 ? "▲" : "▼"} {Math.abs(Number(delta))}%
            </span>
          )}
          <span>{delta !== undefined && delta !== null ? deltaLabel || hint : hint}</span>
        </div>
      )}
    </div>
  );
  if (to) return <Link to={to} className="block h-full">{inner}</Link>;
  if (onClick) return <button type="button" onClick={onClick} className="block h-full w-full text-left">{inner}</button>;
  return inner;
};

export default StatTile;
